import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { toast } from "react-toastify";
import API from "../Services/Report";
import APIS from "../Services/TaxRate";
import * as XLSX from "xlsx";

const PartyReport = forwardRef(
  ({ filters, selectedCenter, resetTrigger, applyTrigger }, ref) => {
    const [partyGst, setPartyGst] = useState([]);
    const [taxRate, setTaxRate] = useState([]);

    const recordsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [fullPartyData, setFullPartyData] = useState([]);
    const [columnTotals, setColumnTotals] = useState({
      netSale: 0,
      gstTotals: {},
      total: 0,
    });

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];

    const bindGetTaxtRate = async () => {
      try {
        const response = await APIS.getTaxRate({ limit: 0, pageNumber: 1 });
        setTaxRate(response?.data?.data?.rows || []);
      } catch (error) {
        toast.error("Error loading tax rates");
      }
    };
    const getpartyReport = async (page = 1) => {
      try {
        const centerList = Array.isArray(selectedCenter)
          ? selectedCenter.join(",")
          : selectedCenter;

        const payloadData = {
          start_date: filters.startDate || formattedPastDate,
          end_date: filters.endDate || formattedToday,
          location_id: centerList?.length > 0 ? centerList : null,
        };

        const response = await API.getPartyGstReport(payloadData);

        if (response?.status === 200 && Array.isArray(response?.data?.result)) {
          const fullData = response.data.result;

          const totalCount = fullData.length;
          setTotalCount(totalCount);

          calculateTotals(fullData);

          // Pagination
          const startIndex = (page - 1) * recordsPerPage;
          const endIndex = startIndex + recordsPerPage;
          const paginatedData = fullData.slice(startIndex, endIndex);

          setPartyGst(paginatedData);
          setTotalPages(Math.ceil(totalCount / recordsPerPage));
          // setCurrentPage(page);

          if (currentPage !== page) {
            setCurrentPage(page);
          }
        } else {
          setPartyGst([]);
          setTotalCount(0);
          setTotalPages(1);

          setColumnTotals({
            netSale: 0,
            gstTotals: {},
            total: 0,
          });
        }
      } catch (error) {
        console.error(error);
        toast.error("Error loading report");

        setPartyGst([]);
        setTotalCount(0);

        setColumnTotals({
          netSale: 0,
          gstTotals: {},
          total: 0,
        });
      }
    };

    const calculateTotals = (data) => {
      let netSale = 0;
      let total = 0;
      let gstTotals = {};

      data.forEach((item) => {
        netSale += Number(item["Net Sale"] || 0);
        total += Number(item["total"] || 0);

        Object.keys(item).forEach((key) => {
          if (key.startsWith("GST")) {
            gstTotals[key] =
              (gstTotals[key] || 0) + Number(item[key] || 0);
          }
        });
      });

      setColumnTotals({
        netSale,
        gstTotals,
        total,
      });
    };

    const downloadCSV = async () => {
      if (totalCount <= 0) {
        toast.info("No data available for download");
        return;
      }
      try {
        const centerList = Array.isArray(selectedCenter)
          ? selectedCenter.join(",")
          : selectedCenter;

        const payloadData = {
          start_date: filters.startDate || formattedPastDate,
          end_date: filters.endDate || formattedToday,
          location_id:
            centerList && centerList.length > 0 ? centerList : null,
          limit: totalCount,
        };

        const response = await API.getPartyGstReport(payloadData);
        if (!response?.data?.result) {
          toast.error("No data available for download");
          return;
        }

        const result = response.data.result;

        const worksheet = XLSX.utils.json_to_sheet(result);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "PartyReport");

        XLSX.writeFile(workbook, "PartyReport.xlsx");

        // toast.success("Party Report downloaded successfully!");
      } catch (error) {
        console.error("Excel Download Failed:", error);
        toast.error("Failed to download report");
      }
    };

    useImperativeHandle(ref, () => ({
      downloadCSV,
    }));

    useEffect(() => {
      bindGetTaxtRate();
    }, []);

    useEffect(() => {
      if (applyTrigger === 0) return;
      getpartyReport(1);
      setCurrentPage(1);
    }, [applyTrigger]);

    useEffect(() => {
      getpartyReport(currentPage);
    }, [currentPage]);

    useEffect(() => {
      setCurrentPage(1);
      getpartyReport(1);
    }, [resetTrigger]);

    const getPageNumbers = () => {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handlePageChange = (page) => {
      if (page < 1 || page > totalPages) return;
      setCurrentPage(page);
    };

    const calculateTotals111 = (data) => {
      let netSaleSum = 0;
      let totalSum = 0;
      let gstTotals = {};

      data.forEach((item) => {
        netSaleSum += Number(item["Net Sale"]) || 0;
        totalSum += Number(item.total) || 0;

        Object.keys(item).forEach((key) => {
          if (key.startsWith("GST")) {
            gstTotals[key] = (gstTotals[key] || 0) + Number(item[key] || 0);
          }
        });
      });
      // console.log('gstTotals', gstTotals);
      setColumnTotals({
        netSale: netSaleSum,
        gstTotals,
        total: totalSum,
      });
    };
    const formatHeader = (key) => {
      return key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
      <div>
        <div className="modern-table-container">
          <div className="modern-table-header">
            <h4>Party Report ({totalCount})</h4>
          </div>

          <div className="p-4 text-center">
            <table className="table table-bordered">
              <thead>

                <tr>
                  <th>#</th>

                  {partyGst.length > 0 &&
                    Object.keys(partyGst[0])
                      .filter(key => key)
                      .map((key, index) => (
                        <th key={index}>{formatHeader(key)}</th>
                      ))}
                </tr>
              </thead>
              <tbody>
                {partyGst.length > 0 ? (
                  partyGst.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>
                        {(currentPage - 1) * recordsPerPage + (rowIndex + 1)}
                      </td>

                      {Object.keys(row)
                        .filter(
                          key => key !== "Center Name" && key !== "center_id"
                        )
                        .map((key, colIndex) => (
                          <td key={colIndex}>
                            {row[key]}

                          </td>
                        ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10">No waiver data available</td>
                  </tr>
                )}
              </tbody>
              {partyGst.length > 0 && (
                <tfoot>
                  <tr>
                    <th></th>

                    {Object.keys(partyGst[0])
                      .filter(key => key !== "Center Name" && key !== "center_id")
                      .map((key) => {
                        if (key === "type") return <th key={key}></th>;

                        if (key === "item_name")
                          return <th key={key}>Total</th>;

                        if (key === "Net Sale")
                          return <th key={key}>{columnTotals.netSale.toFixed(2)}</th>;

                        if (key.startsWith("GST"))
                          return (
                            <th key={key}>
                              {(columnTotals.gstTotals[key] || 0).toFixed(2)}
                            </th>
                          );

                        if (key === "total")
                          return <th key={key}>{columnTotals.total.toFixed(2)}</th>;

                        return <th key={key}></th>;
                      })}
                  </tr>
                </tfoot>
              )}
              {/* {partyGst.length > 0 && (
                <tfoot>
                  <tr>
                    <th></th>
                    <th>Total</th>

                    <th>{columnTotals.netSale.toFixed(2)}</th>

                    {taxRate
                      ?.filter((t) => t.is_active)
                      ?.sort((a, b) => a.rate - b.rate)
                      ?.map((tax) => {
                        const key = `GST ${tax.rate} %`;
                        return (
                          <th key={tax.id}>
                            {columnTotals.gstTotals[key]?.toFixed(2) || "0.00"}
                          </th>
                        );
                      })}

                    <th>{columnTotals.total.toFixed(2)}</th>
                  </tr>
                </tfoot>
              )} */}
            </table>

            <nav>
              <ul className="pagination justify-content-center mt-4">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {getPageNumbers().map((page, i) => (
                  <li
                    key={i}
                    className={`page-item ${page === currentPage ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>

          </div>
        </div>
      </div>
    );
  }
);

export default PartyReport;
